<div class="global-proxy" *ngIf="globalProxy">
  <bzg-modal-header>
    <span class="bzg-modal__header__title">{{'PROXY.TITLE'|translate}}</span>
  </bzg-modal-header>
  <bzg-modal-content>
    <biz-proxy-object [proxyObj]="environment"></biz-proxy-object>
  </bzg-modal-content>
  <bzg-modal-footer>
    <bzg-button-primary (click)="save()">Save</bzg-button-primary>
  </bzg-modal-footer>
</div>
